window.axios = require('axios');
require('../js/components/logger.js');


(function($) {
    console.log("Meow!");
    $('[data-toggle="tooltip"]').tooltip();

    window.addEventListener('load', (event) => {
        if(window.cookieconsent){
            console.log('Cookie!');
            window.cookieconsent.initialise({
                "palette": {
                    "popup": {
                        "background": "#edeff5",
                        "text": "#838391"
                    },
                    "button": {
                        "background": "#4b81e8"
                    }
                },
                "theme": "classic",
                "position": "bottom",
                //"static": true,
                "type": "opt-out",
                "content": {
                    "message": "We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic.",
                    "dismiss": "Accept",
                    "deny": "Decline",
                    "link": "Learn more",
                    "href": "https://www.dulypaid.com/legal/cookies/"
                }
            });
        }
      });
    
}(jQuery));